import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ServiceHistoryPage } from "@/components/ServiceHistoryButton";
import { OperatorContext, useOperators } from "@/components/mobile/operators";
import { OperatorMark } from "@/components/mobile/OperatorLogo";
import { lastOp, rememberOp } from "@/components/mobile/WithOperator";
import DealerItaliaMobile from "@/pages/DealerItaliaMobile";
import AdminItaliaMobile from "@/pages/AdminItaliaMobile";

export default function ConsoleSim() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [params, setParams] = useSearchParams();
  const [flags, setFlags] = useState(null);
  const ops = useOperators();
  useEffect(() => { api.get("/feature-flags").then((r) => setFlags(r.data.flags || {})).catch(() => setFlags({})); }, []);
  if (!flags || !ops) return <p className="text-sm text-muted-foreground">Caricamento…</p>;
  const all = [...ops.filter((o) => o.kind === "sim").map((o) => ({ key: o.key, label: o.name, flag: "italiamobile", op: o })), { key: "esim", label: "SiMamma", flag: "esim", op: ops.find((o) => o.kind === "esim") }];
  const tabs = all.filter((t) => isAdmin || flags[t.flag] !== false);
  if (!tabs.length) return <p className="text-sm text-muted-foreground" data-testid="console-sim-disabled">Servizio non attivo per il tuo account.</p>;
  const cur = tabs.find((t) => t.key === params.get("tab")) || tabs.find((t) => t.key === lastOp()) || tabs[0];
  return (
    <div className="space-y-4" data-testid="console-sim-page">
      {tabs.length > 1 && <Tabs value={cur.key} onValueChange={(v) => { rememberOp(v); setParams({ tab: v }); }}><TabsList className="h-auto flex-wrap" data-testid="console-sim-tabs">
        {tabs.map((t) => <TabsTrigger key={t.key} value={t.key} title={t.label} aria-label={t.label} data-testid={`console-sim-tab-${t.key}`}
          className="gap-2 origin-center transition-[transform,opacity,filter] duration-200 data-[state=inactive]:scale-90 data-[state=inactive]:opacity-60 data-[state=inactive]:grayscale hover:data-[state=inactive]:opacity-90 hover:data-[state=inactive]:grayscale-0">
          {t.op ? <OperatorMark op={t.op} testid={`console-sim-tab-logo-${t.key}`} /> : t.label}</TabsTrigger>)}
      </TabsList></Tabs>}
      {cur.key === "esim" ? <ServiceHistoryPage service="esim" standalone title="Console SIM SiMamma" />
        : <OperatorContext.Provider value={cur.op}><div key={cur.key}>{isAdmin ? <AdminItaliaMobile /> : <DealerItaliaMobile />}</div></OperatorContext.Provider>}
    </div>
  );
}
